export default {
	styleOverrides: {
		root: {
			height: '48px',
		},
	},
};
